import { store } from "../store/store";
import { hasAccessToRoute } from "./route-access";

export const authGuard = (to, from, next) => {
  if (store.state.apiKey) {
    hasAccessToRoute(to) ? next() : next("/home");
  } else {
    //if there's no api key check local storage
    store.dispatch("checkAuth", to);
  }
};



// WEBPACK FOOTER //
// ./src/router/auth-guard.js